import { useLocation } from "react-router-dom";

function useUrlQueryParams() {
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);

  // Extract parameters
  const group = searchParams.get("group");
  const page = searchParams.get("page");
  const form = searchParams.get("form");
  const document = searchParams.get("document");
  const redirectUrl = searchParams.get("redirectUrl");
  const pfilterRaw = searchParams.get("url_pfilters") || searchParams.get("url_pfilter") || searchParams.get("pfilter") || searchParams.get("pfilters");
  const url_pfilters = pfilterRaw;

  return { group, page, form, document, redirectUrl, pfilters: pfilterRaw, pfilter: pfilterRaw, url_pfilter: pfilterRaw, url_pfilters };
}

export default useUrlQueryParams;
